module.exports = __webpack_public_path__ + "static/media/bg_receive@2x.0601012e.png";